module.exports = __webpack_public_path__ + "img/yjcl_orange.50bac68f.gif";